import React, { useEffect } from "react";
import Header from "../../../components/header";
import "./environment.css";
import HomeVideo from "../../../assets/environment_background.jpg";
import { ParallaxProvider } from "react-scroll-parallax";
//import TargetsCharts from "./TargetsCharts";
import Spotlight from "./spotlight";
import FlipCard from "./FlipCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

export default function Environment() {

  const handleScrollToNext = () => {
    const nextSection = document.getElementById("the-connection");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ParallaxProvider>
      <div className="screen-page">
        <Header />
        {/* section 01 */}
        {/* home video */}
        <div style={{ position: "relative" }}>
          <div className="home-page-video">
            <div>
              <img
                src={HomeVideo}
                style={{ height: "calc(100vh - 120px)", width: "100%", objectFit: "cover" }}
                alt=""
              />
              {/* <video
              autoPlay
              loop
              muted
              className="home-video"
              style={{ height: "100vh", width: "100%", objectFit: "cover" }}
            >
              <source src={HomeVideo} type="video/mp4" />
            </video> */}
            </div>
          </div>

          {/* <div style={{ marginLeft: "20px" }}>
            <div className="environment-text-box">
              <div>
                <Parallax speed={10}>
                  <h1 className="environment-topic-home">ENVIRONMENT</h1>
                </Parallax>
              </div>
            </div>
          </div> */}

          {/* White Box */}
          <div className="white-box">
            <div className="white-box-container">
              {/* <h1>
                Modern <span className="white-box-container-h1">& Unique</span>
              </h1> */}
              <div className="screen-pc">
                <h1 className="white-box-container-h1-text">
                  {/* Conserve <br /> */}
                  <span className="white-box-container-h1">Environment</span>
                </h1>
              </div>

              <div className="screen-mobile">
                <p className="white-box-container-h1-text">
                {/* Conserve <br /> */}
                  <span className="white-box-container-h1">
                  Environment <br />
                  </span>
                </p>
              </div>

              {/* Button to scroll to the next section */}
              <div onClick={handleScrollToNext} className="scroll-button">
                <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: "16px" }} />
              </div>
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "calc(100vh - 120px)",
              backgroundColor: "rgba(0, 0, 0, 0.45)",
              zIndex: 0,
            }}
          ></div>

          {/* H Letter Design */}
          <div className="h-banner-container">
            {/* Left Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-left"></div>
            </div>

            {/* Middle Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-design-N">
                <div className="h-left-N"></div>
                <div style={{ height: "350px" }} />
                <div className="h-right-N"></div>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-right"></div>
            </div>
          </div>

        </div>

        {/* section-2 */}

        <div>
          <div className="environment-animation-para">
                <center className="environment-animation-para-center">
                  <p id="the-connection">
                    The connection between community and environment is
                    important to Hirdaramani. Our enduring belief is that we
                    must foster a greater sense of sustainability among all
                    people – well beyond those within our factory walls – to
                    create a better future.
                  </p>
                  <p>
                    We’re proud to not only drive our own environmental projects
                    in the communities we operate but also support local-led
                    initiatives. We focus extensively on engaging with schools
                    and children to instill a love of the environment from a
                    young age.
                  </p>
                  {/* <p
                  className="environment-animation-para-center-yello-p"
                  data-aos="fade-in"
                  data-aos-duration="2000"
                  data-aos-delay="500"
                >
                  80% of supervisors to be reached through career advancement
                  programs.
                  <br />
                  60% of executives to be reached through career advancement
                  programs.
                </p> */}
                </center>
          </div>
        </div>

        {/* section-4 */}
        <Spotlight />

        {/* Section - 5 */}
        <FlipCard />
      </div>
    </ParallaxProvider>
  );
}
